import { usePermissions } from '@/components/auth/RequireRole';
import { useOrganization } from '@/hooks/api/useOrgMembers';

/**
 * Whether the caller may read administration data: the audit log, system
 * settings, legacy accounts, roles and permissions. Matches the backend role
 * policy (internal/auth/rolepolicy adminReads): admins of the selected
 * organization, plus platform admins whatever their role in it.
 */
export function useCanReadAdminData(): boolean {
  const { isAdmin } = usePermissions();
  const { data: organization } = useOrganization();
  return isAdmin || organization?.platform_admin === true;
}
